import { createRoot } from "react-dom/client";
import "./index.css";

import * as Sentry from "@sentry/react";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import { ToastProvider } from "./contexts/ToastContext";
import versionInfo from "../../version.json";

const {
  VITE_SENTRY_DSN: dsn,
  VITE_SENTRY_ENVIRONMENT: environment,
  VITE_ENABLE_SENTRY: sentryEnabledRaw,
} = import.meta.env;

const release = `kindmore-frontend@${versionInfo.version}`;
const sentryEnabled = (sentryEnabledRaw || "false").toLowerCase() === "true";

if (sentryEnabled && dsn) {
  Sentry.init({
    dsn,
    environment,
    release,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  const requestIdle =
    window.requestIdleCallback || ((cb) => setTimeout(cb, 200));
  requestIdle(
    () => {
      import("./sentryReplay.js").then(({ initSentryReplay }) =>
        initSentryReplay()
      );
    },
    { timeout: 2000 }
  );
}

// Lazy route chunks are fetched on navigation; after a deploy the old hashed
// files no longer exist, so reload to pick up the new index.html.
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById("root")).render(
  <BrowserRouter basename="/app/">
    <ToastProvider>
      <App />
    </ToastProvider>
  </BrowserRouter>
);
